import isEmpty from 'lodash/isEmpty'
import Cookies from 'js-cookie'
import Vue from 'vue'
import Vuex from 'vuex'

const COOKIE_ID = 'product_comparison'
const MAX_PRODUCTS = 3

let fetchController = new AbortController()

/**
 * @returns {string[]}
 */
function getProductIdsFromCookie() {
  const cookieVal = Cookies.get(COOKIE_ID)
  if (!cookieVal) {
    return []
  }
  const ids = cookieVal.split(',')
  if (!Array.isArray(ids)) {
    return []
  }
  return ids.map(Number)
}

const store = new Vuex.Store({
  state: {
    productIds: getProductIdsFromCookie(),
    products: {},
    comparisonUrl: null,
  },
  mutations: {
    setProductIds(state, products) {
      state.productIds = products
    },
    addProduct(state, product) {
      state.productIds.push(product.id)
      Vue.set(state.products, product.id, product)
    },
    removeProduct(state, id) {
      const idx = state.productIds.findIndex((_id) => _id === id)
      if (idx !== -1) {
        state.productIds.splice(idx, 1)
      }

      if (id in state.products) {
        Vue.delete(state.products, id)
      }
    },
    setProducts(state, products) {
      state.products = products
    },
    setComparisonUrl(state, url) {
      state.comparisonUrl = url
    },
  },

  actions: {
    async loadProductInfo({ commit }) {
      fetchController.abort()
      fetchController = new AbortController()

      await fetch(window.APP.urls.product_comparison_overview, {
        signal: fetchController.signal,
        method: 'get',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if ('error' in data) {
            alert(data.error)
            return false
          }
          if (!isEmpty(data.products)) {
            commit('setProducts', data.products)
          }
          commit('setComparisonUrl', data.comparisonUrl)
          return data
        })
    },
  },
})

export default store
export { getProductIdsFromCookie, COOKIE_ID, MAX_PRODUCTS }
